import logger from '../../utils/logger';
import { v4 as uuidv4 } from 'uuid';
import { getNextPageGroupId } from '../../api/api';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from '../useTranslation';
import { centerChildInParent } from '../../utils/swimlaneUtils';

export const useSwimlaneAddNode = ({
  ChildNodes,
  setChiledNodes,
  nodes, // grid nodes
  currentParentId,
  currentLevel,
  setHasUnsavedChanges,
  handleLabelChange,
  selectedGroupId,
  selectedexistigrolenodeId,
  langMapRef,
  processLangRef,
}) => {
  const t = useTranslation();
  const addNode = async (type, position, label = '', existingNodeData = null, edgeId = null) => {
    let PageGroupId;
    const Page_Title = 'Swimlane';
    if (!ChildNodes[0]?.page_group_id) {
      try {
        const response = await getNextPageGroupId(Page_Title);
        PageGroupId = response.next_PageGroupId;
      } catch (error) {
        logger.error('next id error', error);
      }
    } else {
      PageGroupId = ChildNodes[0]?.page_group_id;
    }

    if (type === 'Yes' || type === 'No' || type === 'FreeText' || type === 'StickyNote') {
      if (!position) {
        CustomAlert.error(
          t('error') || 'Error',
          t('position_not_defined') || 'Position not defined'
        );
        return;
      }

      const newNodeId = uuidv4().replace(/-/g, '').substring(0, 6);
      const newNode = {
        id:
          currentParentId !== null
            ? `level${currentLevel}_${newNodeId}_${currentParentId}`
            : `level${currentLevel}_${newNodeId}`,

        data: {
          label: type === 'FreeText' || type === 'StickyNote' ? label : '',
          edgeId: edgeId || existingNodeData?.edgeId || null,
          ...(existingNodeData || {}),
          shape: type,
          onLabelChange: (newLabel) =>
            handleLabelChange(
              currentParentId !== null
                ? `level${currentLevel}_${newNodeId}_${currentParentId}`
                : `level${currentLevel}_${newNodeId}`,
              newLabel
            ),
          defaultwidt: '40px',
          defaultheight: '40px',
          translations:
            type === 'FreeText'
              ? existingNodeData?.translations || {
                  [langMapRef.current[Number(processLangRef.current)] || 'EN']: label,
                }
              : {},
          width_height:
            type === 'StickyNote' ? { width: 240, height: 180 } : { width: 326, height: 90 },
          autoFocus: true,

          nodeResize: false,

          updateWidthHeight: (id, size) => {
            setChiledNodes((prevNodes) =>
              prevNodes.map((node) =>
                node.id === id
                  ? {
                      ...node,
                      data: {
                        ...node.data,
                        width_height: size,
                      },
                    }
                  : node
              )
            );
          },
        },
        type: type,
        position: position,
        draggable: true,
        zIndex: 10,
        isNew: true,
        animated: true,
        page_title: 'Swimlane',
        status: 'draft',
        page_group_id: PageGroupId,
      };

      setChiledNodes((nds) => [...nds, newNode]);
      setHasUnsavedChanges(true);
    } else if (selectedGroupId) {
      const selectedGroup = nodes.find((node) => node.id === selectedGroupId);

      const nodebgwidth = document.querySelector('.react-flow__node');
      const nodebgwidths = nodebgwidth ? nodebgwidth.getBoundingClientRect().width : 0;

      const nodebgheight = document.querySelector('.react-flow__node');
      const nodebgheights = nodebgheight ? nodebgheight.getBoundingClientRect().height : 0;

      const groupWidth = nodebgwidths;
      const groupHeight = nodebgheights;
      const childWidth = groupWidth * 0.9;
      const childHeight = groupHeight * 0.9;
      const centeredPosition = centerChildInParent(selectedGroup, {
        style: { childWidth, childHeight },
      });

      const newNodeId = uuidv4();
      const newNode = {
        id:
          currentParentId !== null
            ? `level${currentLevel}_${newNodeId}_${currentParentId}`
            : `level${currentLevel}_${newNodeId}`,
        node_id:
          currentParentId !== null
            ? `level${currentLevel}_${newNodeId}_${currentParentId}`
            : `level${currentLevel}_${newNodeId}`,

        parentNode: selectedGroupId,
        data: existingNodeData
          ? {
              ...existingNodeData,
              onLabelChange: (newLabel) =>
                handleLabelChange(
                  currentParentId !== null
                    ? `level${currentLevel}_${newNodeId}_${currentParentId}`
                    : `level${currentLevel}_${newNodeId}`,
                  newLabel
                ),
              onTitleChange: (newLabel) =>
                handleLabelChange(
                  currentParentId !== null
                    ? `level${currentLevel}_${newNodeId}_${currentParentId}`
                    : `level${currentLevel}_${newNodeId}`,
                  newLabel
                ),
            }
          : {
              label: label,
              details: { title: label, content: '' },
              link: selectedexistigrolenodeId ? selectedexistigrolenodeId : '',
              autoFocus: true,
              shape: type,
              onLabelChange: (newLabel) =>
                handleLabelChange(
                  currentParentId !== null
                    ? `level${currentLevel}_${newNodeId}_${currentParentId}`
                    : `level${currentLevel}_${newNodeId}`,
                  newLabel
                ),
              onTitleChange: (newLabel) =>
                handleLabelChange(
                  currentParentId !== null
                    ? `level${currentLevel}_${newNodeId}_${currentParentId}`
                    : `level${currentLevel}_${newNodeId}`,
                  newLabel
                ),

              defaultwidt: '40px',
              defaultheight: '40px',
              nodeResize: false,
            },
        type: type,
        position: centeredPosition,
        draggable: true,
        isNew: true,
        animated: true,
        page_title: 'Swimlane',
        status: 'draft',
        page_group_id: PageGroupId,
        style: {
          width: nodebgwidths,
          childWidth: nodebgwidths,
          childHeight: nodebgheights,
          height: nodebgheights,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      };

      setChiledNodes((nds) => [...nds, newNode]);
      setHasUnsavedChanges(true);
    } else {
      CustomAlert.warning(
        t('warning') || 'Warning',
        t('please_select_a_group_node_first') || 'Please select a group node first!'
      );
    }
  };

  return { addNode };
};
